import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth token is sent via Authorization header. The token is read from
// localStorage on each request. Ideal future state: migrate to httpOnly
// cookies (backend already supports this), once the ingress CORS allows
// credentials mode (currently the platform proxy responds with
// "Access-Control-Allow-Origin: *" which forbids credentials).
export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (resp) => resp,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("token");
        }
        return Promise.reject(err);
    }
);
